var React = require('react');

function IconHelp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M12.8 21.2h2.4v-2.4h-2.4zM14 2a12 12 0 1 0 12 12A12 12 0 0 0 14 2zm0 21.6a9.6 9.6 0 1 1 9.6-9.6 9.613 9.613 0 0 1-9.6 9.6zm0-16.8a4.8 4.8 0 0 0-4.8 4.8h2.4a2.4 2.4 0 0 1 4.8 0c0 2.4-3.6 2.1-3.6 6h2.4c0-2.7 3.6-3 3.6-6A4.8 4.8 0 0 0 14 6.8z","transform":"translate(-2 -2)"}));
}

IconHelp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconHelp;

IconHelp.default = IconHelp;
